module.exports = __webpack_public_path__ + "static/img/avatar_default.4da808b3.svg";